export default "__VITE_ASSET__DZ5dLPz1__"